// material-ui
import logoHorizontal from 'assets/images/logo_h.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoH = () => <img src={logoHorizontal} alt="Logo" width={180} />;

export default LogoH;
